export default __webpack_public_path__ + "static/media/cnpq.6d46d8bc.png";